import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div\n  class=\'header-environment-name\'\n  tabindex=\'-1\'\n  {{on \'click\' @hideEnvironmentName}}\n>\n  {{@environmentName}}\n</div>")